import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Editor from './components/Editor';
import Viewer from './components/Viewer';
import './App.css';

function PresentationApp() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="editor/:presentationId" element={<Editor />} />
      <Route path="pde" element={<Viewer />} />
      <Route path="*" element={
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: '#1a1a1a',
          color: 'white'
        }}>
          <h1>Link2.do Presentation</h1>
          <h2>Página não encontrada</h2>
          <p>A URL solicitada não existe.</p>
          <a href="/presentation" style={{ 
            marginTop: '20px', 
            color: '#3498db', 
            textDecoration: 'none',
            padding: '10px 20px',
            border: '1px solid #3498db',
            borderRadius: '4px'
          }}>
            Voltar para Apresentações
          </a>
        </div>
      } />
    </Routes>
  );
}

export default PresentationApp;